import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GradingCategoryForm from '../../../components/forms/GradingCategoryForm';
import { useGradingCategoryApi } from '../../../hooks/useGradingCategoryApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { GradingCategoryDTO } from '../../../services/apiClient';

const GradingCategoryCreate: React.FC = () => {
  const { create, isLoading } = useGradingCategoryApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Grading Categories', href: '/admin/gradingcategories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: GradingCategoryDTO) => {
    try {
      await create(data);
      navigate('/admin/gradingcategories');
    } catch (error) {
      console.error('Error creating Grading Category:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/gradingcategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.GradingCategory.Edit'
    >
        <GradingCategoryForm
          initialValues={{} as GradingCategoryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/gradingcategories')}
        />
    </AdminLayout>
  );
};

export default GradingCategoryCreate;